const pruef_PlanConstants = {
  GET_PruefGroup_SUCCESS: " GET_PruefGroup_SUCCESS",
  GET_PruefGroup_FAILURE: "GET_PruefGroup_FAILURE",
  ADDORUPDATE_PruefGroup_SUCCESS: "ADDORUPDATE_PruefGroup_SUCCESS",
  ADDORUPDATE_PruefGroup_FAILURE: "ADDORUPDATE_PruefGroup_FAILURE",
  DELETE_PruefGroup_SUCCESS: "DELETE_PruefGroup_SUCCESS",
  DELETE_PruefGroup_FAILURE: "DELETE_PruefGroup_FAILURE",
  GET_PruefPlan_SUCCESS: " GET_PruefPlan_SUCCESS",
  GET_PruefPlan_FAILURE: "GET_PruefPlan_FAILURE",
  GET_ActivePruefPlan_SUCCESS: " GET_ActivePruefPlan_SUCCESS",
  GET_ActivePruefPlan_FAILURE: " GET_ActivePruefPlan_FAILURE",
  GET_KostPruefGroups_SUCCESS: " GET_KostPruefGroups_SUCCESS",
  GET_KostPruefGroups_FAILURE: " GET_KostPruefGroups_FAILURE",
  ADDORUPDATE_PruefPlan_SUCCESS: "ADDORUPDATE_PruefPlan_SUCCESS",
  ADDORUPDATE_PruefPlan_FAILURE: " ADDORUPDATE_PruefPlan_FAILURE",
  DELETE_PruefPlan_SUCCESS: "DELETE_PruefPlan_SUCCESS",
  DELETE_PruefPlan_FAILURE: "DELETE_PruefPlan_FAILURE",
  GET_PruefPlanQuestion_SUCCESS: "GET_PruefPlanQuestion_SUCCESS",
  GET_PruefPlanQuestion_FAILURE: "GET_PruefPlanQuestion_FAILURE",
  ADDORUPDATE_PruefPlanQuestion_SUCCESS:
    "ADDORUPDATE_PruefPlanQuestion_SUCCESS",
  ADDORUPDATE_PruefPlanQuestion_FAILURE:
    "ADDORUPDATE_PruefPlanQuestion_FAILURE",
  COPY_PruefPlan_SUCCESS: "COPY_PruefPlan_SUCCESS",
  COPY_PruefPlan_FAILURE: "COPY_PruefPlan_FAILURE",
  GET_Equipment_PruefPlan_SUCCESS: "GET_Equipment_PruefPlan_SUCCESS",
  GET_Equipment_PruefPlan_FAILURE: "GET_Equipment_PruefPlan_FAILURE",
  ADDORUPDATE_Equipment_PruefPlan_SUCCESS:
    "ADDORUPDATE_Equipment_PruefPlan_SUCCESS",
  ADDORUPDATE_Equipment_PruefPlan_FAILURE:
    "ADDORUPDATE_Equipment_PruefPlan_FAILURE",
  PUBLISH_PruefPlan_SUCCESS: "PUBLISH_PruefPlan_SUCCESS",
  PUBLISH_PruefPlan_FAILURE: "PUBLISH_PruefPlan_FAILURE",
  DELETE_Equipment_PruefPlan_SUCCESS: "DELETE_Equipment_PruefPlan_SUCCESS",
  DELETE_Equipment_PruefPlan_FAILURE: "DELETE_Equipment_PruefPlan_FAILURE",

  ACTIVATE_PruefPlan_SUCCESS: "ACTIVATE_PruefPlan_SUCCESS",
  ACTIVATE_PruefPlan_FAILURE: "ACTIVATE_PruefPlan_FAILURE",

  DEACTIVATE_PruefPlan_SUCCESS: "DEACTIVATE_PruefPlan_SUCCESS",
  DEACTIVATE_PruefPlan_FAILURE: "DEACTIVATE_PruefPlan_FAILURE",

  GET_CHECKLIST_SUCCESS: "GET_CHECKLIST_SUCCESS",
  GET_CHECKLIST_FAILURE: "GET_CHECKLIST_FAILURE",

  GET_CHECKLIST_DETAILS_SUCCESS: "GET_CHECKLIST_DETAILS_SUCCESS",
  GET_CHECKLIST_DETAILS_FAILURE: "GET_CHECKLIST_DETAILS_FAILURE",

  PUBLISH_CHECKLIST_SUCCESS: "PUBLISH_CHECKLIST_SUCCESS",
  PUBLISH_CHECKLIST_FAILURE: "PUBLISH_CHECKLIST_FAILURE",

  GET_CHECKLIST_FOR_EQ_GRP_SUCCESS: "GET_CHECKLIST_FOR_EQ_GRP_SUCCESS",
  GET_CHECKLIST_FOR_EQ_GRP_FAILURE: "GET_CHECKLIST_FOR_EQ_GRP_FAILURE",

  DEACTIVATE_CHECKLIST_SUCCESS: "DEACTIVATE_CHECKLIST_SUCCESS",
  DEACTIVATE_CHECKLIST_FAILURE: "DEACTIVATE_CHECKLIST_FAILURE",

  DELETE_CHECKLIST_SUCCESS: "DELETE_CHECKLIST_SUCCESS",
  DELETE_CHECKLIST_FAILURE: "DELETE_CHECKLIST_FAILURE",

  SAVE_CHECKLIST_AS_TEMPLATE_SUCCESS: "SAVE_CHECKLIST_AS_TEMPLATE_SUCCESS",
  SAVE_CHECKLIST_AS_TEMPLATE_FAILURE: "SAVE_CHECKLIST_AS_TEMPLATE_FAILURE",

  GET_CHECKLIST_TEMPLATES_SUCCESS: "GET_CHECKLIST_TEMPLATES_SUCCESS",
  GET_CHECKLIST_TEMPLATES_FAILURE: "GET_CHECKLIST_TEMPLATES_FAILURE",

  DELETE_CHECKLIST_TEMPLATE_SUCCESS: "DELETE_CHECKLIST_TEMPLATE_SUCCESS",
  DELETE_CHECKLIST_TEMPLATE_FAILURE: "DELETE_CHECKLIST_TEMPLATE_FAILURE",
};

export default pruef_PlanConstants;
